import { gql } from "@apollo/client";

export const GET_DISPUTE_TRACKING = gql`
  query DisputeTracking($params: GetDisputeTrackingInput) {
    disputeTracking(params: $params) {
      items {
        id
        invoiceNumber
        ticketNumber
        ticketUrl
        disputedAmount
        reason
        raisedBy
        disputeDate
        disputeCloseDate
        disputeAgeDays
        purchaserId
        purchaserKey
        purchaserName
        disputeStatusId
        disputeStatusKey
        disputeStatusName
        isNew
      }
      summary {
        purchaserId
        purchaserName
        totalCount
      }
      statusCounts {
        disputeStatusId
        count
      }
      total
      allCount
      page
      limit
    }
  }
`;
